// Axios interceptor that fires PostHog product/login events on successful
// mutating requests. Named distinctly from apiTelemetry.js (see open PR #809,
// which owns that filename for a separate generic HTTP-outcome interceptor
// shipping to gitcha-observability) to avoid colliding with it - both can
// coexist as independent response interceptors on the shared axios instance.
import { trackEvent } from "./analytics";

let installed = false;

const LOGIN_PATH = /\/auth\/(logon|login|oauth|googleLogin)/i;

const PRODUCT_EVENTS = [
  { re: /\/wantad\/saveWantAd/i, event: "want_listing_created" },
  { re: /\/inventory\/saveInventory/i, event: "inventory_added" },
  { re: /\/introduction\/saveIntroductions/i, event: "intro_sent" },
];

const base = () =>
  typeof window !== "undefined" ? window.location.origin : "http://localhost";

const resolveUrl = (config) => {
  const raw = config?.url || "";
  if (config?.baseURL && !/^https?:\/\//i.test(raw)) {
    return `${config.baseURL.replace(/\/$/, "")}/${raw.replace(/^\//, "")}`;
  }
  return raw;
};

const normalizePath = (config) => {
  try {
    return new URL(resolveUrl(config), base()).pathname;
  } catch {
    return "";
  }
};

const trackKeyEvent = (config) => {
  const path = normalizePath(config);
  if (!path) return;

  if (LOGIN_PATH.test(path)) {
    trackEvent({
      name: "user_logged_in",
      attributes: { method: /oauth|googleLogin/i.test(path) ? "oauth" : "password", path },
    });
    return;
  }

  const match = PRODUCT_EVENTS.find((m) => m.re.test(path));
  if (match) trackEvent({ name: match.event, attributes: { path } });
};

export const installPosthogApiTelemetry = (client) => {
  if (installed || !client?.interceptors) return;
  installed = true;

  try {
    client.interceptors.response.use((response) => {
      try {
        trackKeyEvent(response.config);
      } catch {
        // never let telemetry break a real response
      }
      return response;
    });
  } catch {
    installed = false;
  }
};
